import React from 'react';
import PropTypes from 'prop-types';
import './Square.css';

const Square = (props) => {
  const { colors } = props;
  const bg = { background: ` ${colors[0]}` };
  const arraySquares = Array(10).fill(<li></li>);
  return (
    <div className="square-block" style={bg}>
      <ul className="squares">
        {arraySquares.map((item, index) => (
          <React.Fragment key={index.toString()}>{item}</React.Fragment>
        ))}
      </ul>
    </div>
  );
};

Square.propTypes = {
  colors: PropTypes.array,
};

export default Square;
